export const hubFr = {
  "nav.guide": "Guide",
  "gd.nav": "Guide",
  "gd.label": "Aide",
  "gd.title1": "Guide ",
  "gd.title2": "CLIP-EX",
  "gd.sub": "Tout ce qu'il faut savoir pour créer, monter et partager tes clips. Une question ? L'assistant IA te répond 24/7.",
  "gd.ask": "Demander à l'assistant IA",
  "gd.search": "Rechercher dans le guide…",
  "gd.faq": "Dépannage (FAQ)",
  "gd.none": "Aucun résultat. Demande à l'assistant IA !",
  "gd.cta_t": "Tu ne trouves pas ta réponse ?",
  "gd.cta_d": "L'assistant IA connaît toute la plateforme. S'il ne peut pas t'aider, il transmet la conversation à l'équipe.",
  "as.title": "CLIP-EX Assist",
  "as.online": "IA en ligne",
  "as.hello": "Salut ! Je suis l'assistant IA de CLIP-EX. Pose-moi ta question sur la plateforme ou décris ton problème.",
  "as.q1": "Comment créer mon premier clip ?",
  "as.q2": "Mon export ne fonctionne pas",
  "as.q3": "Comment utiliser un code cadeau ?",
  "as.q4": "Comment connecter OBS ?",
  "as.ph": "Écris ta question…",
  "as.human": "Parler à un humain",
  "as.sent": "Transmis au support — voir mes tickets",
  "as.sent_toast": "Conversation envoyée à l'équipe CLIP-EX. Tu recevras une réponse dans Support.",
  "as.sent_badge": "transmis",
  "as.history": "Mes conversations",
  "as.no_history": "Aucune conversation pour l'instant.",
  "as.new": "Nouvelle conversation",
  "as.err": "L'assistant est momentanément indisponible.",
  "nav.releases": "Nouveautés",
  "nav.suggestions": "Suggestions",
  "nav.support": "Support",
  "nav.admin": "Master Center",

  "auth.consent_1": "J'ai lu et j'accepte les ",
  "auth.consent_terms": "Conditions d'utilisation",
  "auth.consent_and": " et la ",
  "auth.consent_privacy": "Politique de confidentialité",
  "auth.consent_2": " de CLIP-EX™. Je consens au traitement de mes renseignements personnels conformément à la Loi 25 (Québec).",
  "auth.consent_required": "Tu dois accepter les conditions pour créer ton compte.",
  "auth.consent_note": "Ton consentement (date, version des conditions, adresse IP) est enregistré comme preuve. Tu peux le retirer en supprimant ton compte.",

  "rel.label": "Journal des versions",
  "rel.title1": "Quoi de ",
  "rel.title2": "neuf ?",
  "rel.sub": "Chaque mise à jour de CLIP-EX, expliquée simplement.",
  "rel.current": "Version actuelle",
  "rel.latest": "Dernière version",
  "rel.empty": "Aucune version publiée pour l'instant.",
  "rel.type_new": "Nouveau",
  "rel.type_improved": "Amélioré",
  "rel.type_fix": "Corrigé",
  "rel.popup_label": "Mise à jour",
  "rel.popup_cta": "C'est parti",
  "rel.popup_all": "Voir toutes les nouveautés",
  "err.generic": "Une erreur est survenue.",
  "st.pos": "Position", "st.anim": "Animation", "st.size": "Taille", "st.duration": "Durée", "st.add": "Ajouter",
  "st.tab_stickers": "Stickers", "st.tab_custom": "Texte perso", "st.tab_sfx": "Sons",
  "st.cat_all": "Tous", "st.cat_hype": "Hype", "st.cat_win": "Victoire", "st.cat_fail": "Fail & fun",
  "st.anim_pop": "Pop", "st.anim_slam": "Slam", "st.anim_bounce": "Rebond", "st.anim_shake": "Tremble", "st.anim_pulse": "Pulsation",
  "st.anim_spin": "Rotation", "st.anim_glitch": "Glitch", "st.anim_slide": "Glissé", "st.anim_none": "Fixe",
  "st.size_s": "S", "st.size_m": "M", "st.size_l": "L",
  "st.style_chrome": "Chrome", "st.style_neon": "Néon", "st.style_fire": "Feu", "st.style_ice": "Glace", "st.style_toxic": "Toxique", "st.style_gold": "Or",
  "st.custom_ph": "Ton mot (ex. CRAZY, 1V5, GOAT)",
  "st.limit": "Maximum {n} atteint pour ce clip",
  "sfx.cat_all": "Tous", "sfx.cat_impact": "Impacts", "sfx.cat_gaming": "Gaming", "sfx.cat_meme": "Mèmes", "sfx.cat_transition": "Transitions",

  "sug.label": "Communauté",
  "sug.title1": "Suggestions ",
  "sug.title2": "des créateurs",
  "sug.sub": "Propose une fonction, vote pour celles des autres. Les idées les plus votées passent en priorité.",
  "sug.new": "Nouvelle suggestion",
  "sug.f_title": "Titre de l'idée",
  "sug.f_body": "Décris ton idée et pourquoi elle t'aiderait",
  "sug.f_category": "Catégorie",
  "sug.submit": "Publier",
  "sug.posted": "Suggestion publiée",
  "sug.sort_top": "Les plus votées",
  "sug.sort_new": "Les plus récentes",
  "sug.all": "Toutes",
  "sug.empty": "Aucune suggestion ici. Sois le premier à proposer une idée.",
  "sug.by": "par",
  "sug.reply": "Réponse de CLIP-EX",
  "sug.delete": "Supprimer",
  "sug.demo": "Crée ton propre compte pour proposer et voter.",
  "sug.cat_feature": "Fonction",
  "sug.cat_effect": "Effets",
  "sug.cat_platform": "Plateformes",
  "sug.cat_ai": "IA",
  "sug.cat_ux": "Interface",
  "sug.cat_other": "Autre",
  "sug.st_new": "Nouvelle",
  "sug.st_review": "À l'étude",
  "sug.st_planned": "Planifiée",
  "sug.st_shipped": "Livrée",
  "sug.st_declined": "Refusée",

  "sup.label": "Aide",
  "sup.title1": "Support ",
  "sup.title2": "CLIP-EX",
  "sup.sub": "Un souci, une question ? Ouvre un ticket, l'équipe te répond ici.",
  "sup.new": "Nouveau ticket",
  "sup.subject": "Sujet",
  "sup.category": "Catégorie",
  "sup.message": "Ton message",
  "sup.send": "Envoyer",
  "sup.created": "Ticket envoyé, on te répond vite",
  "sup.mine": "Mes tickets",
  "sup.empty": "Aucun ticket pour l'instant.",
  "sup.pick": "Sélectionne un ticket pour voir la conversation.",
  "sup.reply_ph": "Écris ta réponse…",
  "sup.reply": "Répondre",
  "sup.close": "Fermer le ticket",
  "sup.closed_note": "Ce ticket est fermé.",
  "sup.new_reply": "Nouvelle réponse",
  "sup.cat_bug": "Bug",
  "sup.cat_account": "Compte",
  "sup.cat_billing": "Crédits",
  "sup.cat_clip": "Clips / export",
  "sup.cat_live": "Live / plateformes",
  "sup.cat_other": "Autre",
  "sup.st_open": "Ouvert",
  "sup.st_answered": "Répondu",
  "sup.st_closed": "Fermé",

  "adm.label": "Propriétaire",
  "adm.title1": "Master ",
  "adm.title2": "Center",
  "adm.sub": "Pilote CLIP-EX : utilisateurs, espaces, versions, suggestions et support.",
  "adm.tab_overview": "Vue d'ensemble",
  "adm.tab_users": "Utilisateurs",
  "adm.tab_workspaces": "Espaces",
  "adm.tab_releases": "Versions",
  "adm.tab_alerts": "Alertes",
  "adm.alerts_sub": "Membres qui ont atteint leurs limites d'imports ou de lives 3 fois ou plus dans les 7 derniers jours.",
  "adm.alerts_empty": "Aucun membre n'a atteint souvent ses limites cette semaine.",
  "adm.alerts_imports": "{n} blocages d'imports",
  "adm.alerts_lives": "{n} blocages de lives",
  "adm.contact": "Écrire",
  "adm.contacted": "Contacté le {d}",
  "adm.contact_title": "Écrire à {e}",
  "adm.contact_send": "Envoyer le courriel",
  "adm.contact_sent": "Courriel envoyé à {e}",
  "adm.contact_subject": "Tu crées beaucoup sur CLIP-EX !",
  "adm.contact_body": "Salut {name} !\n\nOn a remarqué que tu atteins souvent tes limites d'imports ou de lives. Bravo pour ton activité !\n\nAvec un forfait de crédits, tes limites par heure sont doublées. Et en ce moment, tu as un bonus de crédits sur ton prochain achat.\n\nUne question ? Réponds simplement à ce courriel.\n\nL'équipe CLIP-EX",
  "lim.title": "Limite atteinte",
  "lim.reason_import": "Tu as atteint ta limite de {n} imports par heure.",
  "lim.reason_live": "Tu as atteint ta limite de {n} lives démarrés par heure.",
  "lim.double": "Avec un forfait de crédits, tes limites doublent : {i} imports et {l} lives par heure.",
  "lim.bonus": "+{p} % de crédits sur ton prochain achat",
  "lim.banner": "Offre spéciale : +{p} % de crédits sur ton prochain achat",
  "lim.expires": "Expire dans {h} h",
  "lim.later": "Plus tard",
  "lim.cta": "Voir les forfaits",
  "adm.tab_suggestions": "Suggestions",
  "adm.tab_support": "Support",
  "adm.s_users": "Utilisateurs",
  "adm.s_users_7d": "Nouveaux (7 j)",
  "adm.s_workspaces": "Espaces",
  "adm.s_videos": "Vidéos",
  "adm.s_clips": "Clips",
  "adm.s_clips_7d": "Clips (7 j)",
  "adm.s_live": "Lives en cours",
  "adm.s_tickets": "Tickets ouverts",
  "adm.s_suggestions": "Suggestions",
  "adm.s_suspended": "Suspendus",
  "adm.s_version": "Version en ligne",
  "adm.search": "Rechercher (email, pseudo, espace)…",
  "adm.suspend": "Suspendre",
  "adm.reactivate": "Réactiver",
  "adm.suspended": "Suspendu",
  "adm.active": "Actif",
  "adm.members": "membres",
  "adm.owner": "Propriétaire",
  "adm.saved": "Enregistré",
  "adm.rel_new": "Publier une nouvelle version",
  "adm.rel_version": "Version (ex. 0.0.1)",
  "adm.rel_title": "Titre",
  "adm.rel_summary": "Résumé",
  "adm.rel_items": "Nouveautés",
  "adm.rel_add_item": "Ajouter une ligne",
  "adm.rel_item_ph": "Décris la nouveauté…",
  "adm.rel_published": "Publiée",
  "adm.rel_draft": "Brouillon",
  "adm.rel_publish": "Publier",
  "adm.rel_save": "Enregistrer",
  "adm.rel_edit": "Modifier",
  "adm.rel_cancel": "Annuler",
  "adm.rel_delete_confirm": "Supprimer cette version ?",
  "adm.sug_reply_ph": "Réponse publique au créateur…",
  "adm.all": "Tous",
  "adm.consent": "Conditions",
};

export const hubEn = {
  "nav.guide": "Guide",
  "gd.nav": "Guide",
  "gd.label": "Help",
  "gd.title1": "CLIP-EX ",
  "gd.title2": "Guide",
  "gd.sub": "Everything you need to create, edit and share your clips. Got a question? The AI assistant answers 24/7.",
  "gd.ask": "Ask the AI assistant",
  "gd.search": "Search the guide…",
  "gd.faq": "Troubleshooting (FAQ)",
  "gd.none": "No results. Ask the AI assistant!",
  "gd.cta_t": "Can't find your answer?",
  "gd.cta_d": "The AI assistant knows the whole platform. If it can't help, it forwards the conversation to the team.",
  "as.title": "CLIP-EX Assist",
  "as.online": "AI online",
  "as.hello": "Hi! I'm the CLIP-EX AI assistant. Ask me anything about the platform or describe your problem.",
  "as.q1": "How do I create my first clip?",
  "as.q2": "My export doesn't work",
  "as.q3": "How do I use a gift code?",
  "as.q4": "How do I connect OBS?",
  "as.ph": "Type your question…",
  "as.human": "Talk to a human",
  "as.sent": "Sent to support — view my tickets",
  "as.sent_toast": "Conversation sent to the CLIP-EX team. You'll get a reply in Support.",
  "as.sent_badge": "sent",
  "as.history": "My conversations",
  "as.no_history": "No conversations yet.",
  "as.new": "New conversation",
  "as.err": "The assistant is temporarily unavailable.",
  "nav.releases": "What's new",
  "nav.suggestions": "Suggestions",
  "nav.support": "Support",
  "nav.admin": "Master Center",

  "auth.consent_1": "I have read and accept the CLIP-EX™ ",
  "auth.consent_terms": "Terms of Use",
  "auth.consent_and": " and ",
  "auth.consent_privacy": "Privacy Policy",
  "auth.consent_2": ". I consent to the processing of my personal information under Québec's Law 25.",
  "auth.consent_required": "You must accept the terms to create your account.",
  "auth.consent_note": "Your consent (date, terms version, IP address) is stored as proof. You can withdraw it by deleting your account.",

  "rel.label": "Release notes",
  "rel.title1": "What's ",
  "rel.title2": "new?",
  "rel.sub": "Every CLIP-EX update, explained simply.",
  "rel.current": "Current version",
  "rel.latest": "Latest",
  "rel.empty": "No release published yet.",
  "rel.type_new": "New",
  "rel.type_improved": "Improved",
  "rel.type_fix": "Fixed",
  "rel.popup_label": "Update",
  "rel.popup_cta": "Let's go",
  "rel.popup_all": "See all updates",
  "err.generic": "Something went wrong.",
  "st.pos": "Position", "st.anim": "Animation", "st.size": "Size", "st.duration": "Duration", "st.add": "Add",
  "st.tab_stickers": "Stickers", "st.tab_custom": "Custom text", "st.tab_sfx": "Sounds",
  "st.cat_all": "All", "st.cat_hype": "Hype", "st.cat_win": "Victory", "st.cat_fail": "Fail & fun",
  "st.anim_pop": "Pop", "st.anim_slam": "Slam", "st.anim_bounce": "Bounce", "st.anim_shake": "Shake", "st.anim_pulse": "Pulse",
  "st.anim_spin": "Spin", "st.anim_glitch": "Glitch", "st.anim_slide": "Slide", "st.anim_none": "Static",
  "st.size_s": "S", "st.size_m": "M", "st.size_l": "L",
  "st.style_chrome": "Chrome", "st.style_neon": "Neon", "st.style_fire": "Fire", "st.style_ice": "Ice", "st.style_toxic": "Toxic", "st.style_gold": "Gold",
  "st.custom_ph": "Your word (e.g. CRAZY, 1V5, GOAT)",
  "st.limit": "Limit of {n} reached for this clip",
  "sfx.cat_all": "All", "sfx.cat_impact": "Impacts", "sfx.cat_gaming": "Gaming", "sfx.cat_meme": "Memes", "sfx.cat_transition": "Transitions",

  "sug.label": "Community",
  "sug.title1": "Creator ",
  "sug.title2": "suggestions",
  "sug.sub": "Suggest a feature and vote for others. The most voted ideas get priority.",
  "sug.new": "New suggestion",
  "sug.f_title": "Idea title",
  "sug.f_body": "Describe your idea and why it would help you",
  "sug.f_category": "Category",
  "sug.submit": "Post",
  "sug.posted": "Suggestion posted",
  "sug.sort_top": "Most voted",
  "sug.sort_new": "Newest",
  "sug.all": "All",
  "sug.empty": "No suggestions here. Be the first to share an idea.",
  "sug.by": "by",
  "sug.reply": "CLIP-EX reply",
  "sug.delete": "Delete",
  "sug.demo": "Create your own account to suggest and vote.",
  "sug.cat_feature": "Feature",
  "sug.cat_effect": "Effects",
  "sug.cat_platform": "Platforms",
  "sug.cat_ai": "AI",
  "sug.cat_ux": "Interface",
  "sug.cat_other": "Other",
  "sug.st_new": "New",
  "sug.st_review": "Under review",
  "sug.st_planned": "Planned",
  "sug.st_shipped": "Shipped",
  "sug.st_declined": "Declined",

  "sup.label": "Help",
  "sup.title1": "CLIP-EX ",
  "sup.title2": "Support",
  "sup.sub": "A problem or a question? Open a ticket and the team replies here.",
  "sup.new": "New ticket",
  "sup.subject": "Subject",
  "sup.category": "Category",
  "sup.message": "Your message",
  "sup.send": "Send",
  "sup.created": "Ticket sent, we'll reply soon",
  "sup.mine": "My tickets",
  "sup.empty": "No tickets yet.",
  "sup.pick": "Select a ticket to see the conversation.",
  "sup.reply_ph": "Write your reply…",
  "sup.reply": "Reply",
  "sup.close": "Close ticket",
  "sup.closed_note": "This ticket is closed.",
  "sup.new_reply": "New reply",
  "sup.cat_bug": "Bug",
  "sup.cat_account": "Account",
  "sup.cat_billing": "Credits",
  "sup.cat_clip": "Clips / export",
  "sup.cat_live": "Live / platforms",
  "sup.cat_other": "Other",
  "sup.st_open": "Open",
  "sup.st_answered": "Answered",
  "sup.st_closed": "Closed",

  "adm.label": "Owner",
  "adm.title1": "Master ",
  "adm.title2": "Center",
  "adm.sub": "Run CLIP-EX: users, workspaces, releases, suggestions and support.",
  "adm.tab_overview": "Overview",
  "adm.tab_users": "Users",
  "adm.tab_workspaces": "Workspaces",
  "adm.tab_releases": "Releases",
  "adm.tab_alerts": "Alerts",
  "adm.alerts_sub": "Members who hit their import or live limits 3 times or more in the last 7 days.",
  "adm.alerts_empty": "No member hit their limits often this week.",
  "adm.alerts_imports": "{n} import blocks",
  "adm.alerts_lives": "{n} live blocks",
  "adm.contact": "Write",
  "adm.contacted": "Contacted on {d}",
  "adm.contact_title": "Write to {e}",
  "adm.contact_send": "Send email",
  "adm.contact_sent": "Email sent to {e}",
  "adm.contact_subject": "You create a lot on CLIP-EX!",
  "adm.contact_body": "Hey {name}!\n\nWe noticed you often reach your import or live limits. Great job staying active!\n\nWith a credit plan, your hourly limits are doubled. And right now you have a credit bonus on your next purchase.\n\nAny question? Just reply to this email.\n\nThe CLIP-EX team",
  "lim.title": "Limit reached",
  "lim.reason_import": "You reached your limit of {n} imports per hour.",
  "lim.reason_live": "You reached your limit of {n} lives started per hour.",
  "lim.double": "With a credit plan, your limits double: {i} imports and {l} lives per hour.",
  "lim.bonus": "+{p}% credits on your next purchase",
  "lim.banner": "Special offer: +{p}% credits on your next purchase",
  "lim.expires": "Expires in {h} h",
  "lim.later": "Later",
  "lim.cta": "See plans",
  "adm.tab_suggestions": "Suggestions",
  "adm.tab_support": "Support",
  "adm.s_users": "Users",
  "adm.s_users_7d": "New (7d)",
  "adm.s_workspaces": "Workspaces",
  "adm.s_videos": "Videos",
  "adm.s_clips": "Clips",
  "adm.s_clips_7d": "Clips (7d)",
  "adm.s_live": "Live now",
  "adm.s_tickets": "Open tickets",
  "adm.s_suggestions": "Suggestions",
  "adm.s_suspended": "Suspended",
  "adm.s_version": "Live version",
  "adm.search": "Search (email, name, workspace)…",
  "adm.suspend": "Suspend",
  "adm.reactivate": "Reactivate",
  "adm.suspended": "Suspended",
  "adm.active": "Active",
  "adm.members": "members",
  "adm.owner": "Owner",
  "adm.saved": "Saved",
  "adm.rel_new": "Publish a new version",
  "adm.rel_version": "Version (e.g. 0.0.1)",
  "adm.rel_title": "Title",
  "adm.rel_summary": "Summary",
  "adm.rel_items": "Changes",
  "adm.rel_add_item": "Add a line",
  "adm.rel_item_ph": "Describe the change…",
  "adm.rel_published": "Published",
  "adm.rel_draft": "Draft",
  "adm.rel_publish": "Publish",
  "adm.rel_save": "Save",
  "adm.rel_edit": "Edit",
  "adm.rel_cancel": "Cancel",
  "adm.rel_delete_confirm": "Delete this version?",
  "adm.sug_reply_ph": "Public reply to the creator…",
  "adm.all": "All",
  "adm.consent": "Terms",
};
